module.exports = __webpack_public_path__ + "resources/img/career-pmImg.33a04009.png";